import LogRocket from 'logrocket'
import Vue from 'vue'

// Init is deferred until after auth in App.vue#setLogRocket so we don't capture
// anonymous landing-page sessions.
Vue.prototype.$LogRocket = LogRocket
